import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Home from './pages/home';
import News from './pages/news';
import Hotels from './pages/hotels';
import RealEstate from './pages/realestate';
import Classifieds from './pages/classifieds';
import GeneralServices from './pages/generalservices';
import Jobs from './pages/jobs';
import Contact from './pages/contact';
import PrivacyPolicy from './pages/privacypolicy';
import Rentals from './pages/rentals';
import Flyers from './pages/flyers';
import Accomodation from './pages/accomodation';
import Header from './components/header';
import Footer from './components/footer';
import Educational from './pages/educational';
import BuyOrSellGeneral from './pages/buyorsellgeneral';
import EventsPlanning from './pages/eventsplanning';
import Specials from './pages/specials';
import GreetingAndWishes from './pages/greetingandwishes';
import HomeHeaderRotateList from './pages/homeheaderrotatelist';

import React, { useEffect, useState } from 'react';

function App() {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [showInstallModal, setShowInstallModal] = useState(false);

  useEffect(() => {
    const handler = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);

      // Show only once per user
      if (!localStorage.getItem('installPromptShown')) {
        setShowInstallModal(true);
        localStorage.setItem('installPromptShown', 'true');
      }
    };

    window.addEventListener('beforeinstallprompt', handler);
    return () => window.removeEventListener('beforeinstallprompt', handler);
  }, []);

  const handleInstall = async () => {
    if (!deferredPrompt) return;
    deferredPrompt.prompt();
    const { outcome } = await deferredPrompt.userChoice;
    console.log(`User response: ${outcome}`);
    setShowInstallModal(false);
    setDeferredPrompt(null);
  };

  const handleDismiss = () => {
    setShowInstallModal(false);
  };

  return (
    <Router>
      <Header />

      <Routes>
        <Route index element={<Home />} />
        <Route path="/home" element={<Home />} />
        <Route path="/news" element={<News />} />
        <Route path="/hotels" element={<Hotels />} />
        <Route path="/realestate" element={<RealEstate />} />
        <Route path="/classifieds" element={<Classifieds />} />
        <Route path="/services" element={<GeneralServices />} />
        <Route path="/jobs" element={<Jobs />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/privacypolicy" element={<PrivacyPolicy />} />
        <Route path="/rentals" element={<Rentals />} />
        <Route path="/flyers" element={<Flyers />} />
        <Route path="/accomodation" element={<Accomodation />} />
        <Route path="/educational" element={<Educational />} />
        <Route path="/eventsplanning" element={<EventsPlanning />} />
        <Route path="/db-events" element={<Navigate to="/eventsplanning" replace />} />
        <Route path="/buyorsellgeneral" element={<BuyOrSellGeneral />} />
        <Route path="/specials" element={<Specials />} />
        <Route path="/greetingandwishes" element={<GreetingAndWishes />} />
        <Route path="/homeheaderrotatelist" element={<HomeHeaderRotateList />} />
        <Route path="/homeheaderrotatelist/:id" element={<HomeHeaderRotateList />} />
      </Routes>

      <Footer />

      {/* ✅ Install Modal */}
      {showInstallModal && (
        <div style={styles.overlay}>
          <div style={styles.modal}>
            <h2 style={{ marginBottom: '10px' }}>Install this website</h2>
            <p style={{ color: '#555', marginBottom: '20px' }}>
              Add a shortcut to your desktop or home screen for quick access.
            </p>
            <div style={styles.buttonContainer}>
              <button style={styles.installButton} onClick={handleInstall}>
                📌 Install
              </button>
              <button style={styles.cancelButton} onClick={handleDismiss}>
                ✖ Dismiss
              </button>
            </div>
          </div>
        </div>
      )}
    </Router>
  );
}

const styles = {
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0,0,0,0.4)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 1000,
  },
  modal: {
    background: 'white',
    padding: '30px',
    borderRadius: '12px',
    boxShadow: '0 8px 20px rgba(0,0,0,0.2)',
    maxWidth: '400px',
    width: '90%',
    textAlign: 'center',
  },
  buttonContainer: {
    display: 'flex',
    justifyContent: 'center',
    gap: '10px',
  },
  installButton: {
    backgroundColor: '#1976d2',
    color: 'white',
    border: 'none',
    borderRadius: '6px',
    padding: '10px 20px',
    cursor: 'pointer',
  },
  cancelButton: {
    backgroundColor: '#ccc',
    color: '#333',
    border: 'none',
    borderRadius: '6px',
    padding: '10px 20px',
    cursor: 'pointer',
  },
};

export default App;
